import { useFormat } from '@ideavivat/vivat-2';
import usePurchaseOrder from '@/use/usePurchaseOrder';
import usePurchaseRequest from '@/use/usePurchaseRequest';

const { statusTranslate, statusClassMap } = usePurchaseOrder();
const { typeTranslate, classMap } = usePurchaseRequest();

export default {
  types: {
    _primaryControls: {
      name: 'เมนู',
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      class: {
        text: (val: string, row: { item: { [key: string]: any }; index: number }) => statusClassMap(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price),
      },
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => statusTranslate(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price),
    },
    // type: {
    //   name: 'ประเภท',
    //   width: '6rem',
    //   class: {
    //     text: (val: string, row: { item: { [key: string]: any }; index: number }) => classMap(val, true),
    //   },
    //   filter: (val: string, row: { item: { [key: string]: any }; index: number }) => typeTranslate(val),
    // },
    code: {
      name: 'เลขที่รายการ',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? val : '-',
    },
    // dueDate: {
    //   name: 'กำหนดส่ง',
    //   width: '12rem',
    //   class: 'text-center',
    //   // eslint-disable-next-line
    //   filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    // },
    supplier: {
      name: 'ชื่อ Supplier',
      width: '1fr',
      class: 'text-left',
      filter: (val: any) => val?.name || '',
    },
    total_price: {
      name: 'ยอดรวม (ก่อน Vat)',
      width: '8rem',
      class: 'text-right text-green',
      filter: (val: any, row: any) => parseFloat((val - row.item.discount || 0) as any).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    creator: {
      name: 'ผู้ทำรายการ',
      width: '12rem',
      class: {
        cell: 'text-right',
        text: 'text-right',
      },
      filter: (val: any) => val?.name || '-',
    },
    updated_at: {
      name: 'วันทำรายการล่าสุด',
      width: '12rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
  },

  sortable: [
    'type',
    'code',
    'updated_at',
  ],
};
